import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { db, auth } from '../../Services/firebase-config.js'; // Import Firestore and Firebase auth instance
import { doc, getDoc } from 'firebase/firestore';

const KibaloContent = () => {
  const navigate = useNavigate();
  const { kibaloId } = useParams();  // Fetch valueChainId from URL parameters
  const [valueChain, setValueChain] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const [isDeleted, setIsDeleted] = useState(false);

  // Clean the valueChainId (in case it includes extra parts like '/details')
  const cleanedId = kibaloId;  // Keep only the part before '/details'

  // Get current user's UID
  const user = auth.currentUser;
  const userUid = user ? user.uid : null;

  // Fetch Value Chain document
  useEffect(() => {
    // Ensure that both cleanedId and userUid are available
    if (cleanedId && userUid) {
      console.log(`Fetching Value Chain Document with ID: ${cleanedId} for User: ${userUid}`);

      const fetchValueChain = async () => {
        // Firestore path now includes the user UID
        setLoading(true); // Start loading
        const docRef = doc(db, `users/${userUid}/kibalos/${cleanedId}`);  // Adjusted Firestore reference
        try {
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            if (data.isDeleted) {
              setIsDeleted(true);
              setValueChain(data); // Still set data to show name if needed
              console.log('Document is marked as deleted.');
            } else {
              setValueChain(data);
              console.log('Document found');
            }
          } else {
            console.error('Value Chain document not found!');
          }
        } catch (error) {
          console.error('Error fetching Value Chain document:', error);
        } finally {
          setLoading(false); // Stop loading
        }
      };

      fetchValueChain();
    } else {
      console.error("cleanedId or userUid is missing.");
    }
  }, [cleanedId, userUid]);  // Dependency on cleanedId and userUid

  const sections = [
    {
      id: 1,
      title: 'Step 1: Costings',
      path: `/basic-costing/${cleanedId}`,
      description: 'CLICK HERE TO START THE COSTING PROCESS.',
      progress: valueChain?.costingProgress ?? 0,
      editors: ['Bob', 'John'],
    }
  ];
  

  const handleAction = (action, id) => {
    console.log(`Action: ${action}, Stage ID: ${id}`);
    // Implement navigation or action logic based on the action and id
  };

  const handleNavigate = (path) => {
    if (valueChain) {
      navigate(path, { state: { valueChain } }); // Pass valueChain document as state
    } else {
      console.error("Value chain data isn't loaded yet.");
    }
  };

  if (loading) {
    return (
      <div className="p-6 bg-gray-50 min-h-screen text-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (isDeleted) {
    return (
      <div className="p-6 bg-gray-50 min-h-screen text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Item Deleted
        </h1>
        <p className="text-gray-600">
          This enterprise analysis '{valueChain?.name || ''}' has been moved to the trash.
        </p>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        Enterprise Analysis For  {valueChain?.name || 'Kibalo Tool'}
      </h1>
      

      <div className="space-y-4">
        {sections.map((section) => (
          <div
            key={section.id}
            className="group bg-white border-l-4 border-blue-500 rounded-r-lg p-6 flex items-center justify-between shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer"
            onClick={() => navigate(section.path)}
          >
            <div className="flex-grow">
              <h2 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                {section.title}
              </h2>
              <p className="text-sm text-gray-600 mt-1">{section.description}</p>
            </div>
            <div className="ml-6">
              <FaArrowRight className="text-gray-400 group-hover:text-blue-600 group-hover:translate-x-2 transition-all duration-300" />
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default KibaloContent;
